import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { ApplicationStore } from 'app/stores/application-store';

/*
  this is a service as it is injectable.
  it does not take the http service as it is not used to communicate with the web api.
  this to be used as a routing guard to provent the user from navigating to pages without logining on

*/
@Injectable()
export class AuthGuardService implements CanActivate {

   constructor(private router: Router, private authService: AuthService, private applicationStore: ApplicationStore) { }

   async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
      const isAuthenticated = await this.authService.isAuthenticated().toPromise();
      if (!isAuthenticated) {
         this.router.navigate(['']);
         return false;
      }

      // in case the user is authenticated but the logged in user is null, we want to navigate them back to the login page
      if (this.applicationStore.authenticationStore.loggedInUser == null) {
         this.router.navigate(['']);
         return false;
      }

      return true;
   }
}
